<div style="height: 100%; width: 100%;"
     leaflet
     [leafletOptions]="options">
</div>
